var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBellSimpleRinging = function SvgIconBellSimpleRinging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.935 2.46A1 1 0 1 0 5.872.766 11.4 11.4 0 0 0 1.68 5.43a1 1 0 0 0 1.797.877A9.4 9.4 0 0 1 6.935 2.46M16.75 1.081a1 1 0 0 1 1.378-.315 11.4 11.4 0 0 1 4.193 4.664 1 1 0 1 1-1.798.877 9.4 9.4 0 0 0-3.458-3.847 1 1 0 0 1-.315-1.379"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.143 7.541c.389.938.589 1.944.589 2.96 0 3.181.657 4.583 1.187 5.498V16a1.75 1.75 0 0 1-1.509 2.625H4.591A1.75 1.75 0 0 1 3.08 16L3.082 16c.53-.915 1.187-2.317 1.187-5.499a7.731 7.731 0 0 1 14.874-2.959M9.807 5.205a5.73 5.73 0 0 1 7.925 5.295c0 3.184.609 4.919 1.248 6.125H5.02c.64-1.206 1.248-2.94 1.248-6.125a5.73 5.73 0 0 1 3.538-5.295",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20.375a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconBellSimpleRinging;